//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const EnableUnneededCalculationFixationSkip: FeatureFlag = {"Id":"EnableUnneededCalculationFixationSkip","Label":"(Performance) Skip fixating calculations with no later consumer","Impact":"When enabled, overrides the default fixation behavior so that submit-time fixation skips calculations that this override determines have no later consumer (not displayed, not referenced, not exported). When disabled, every calculation is fixated as before.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
